import React from 'react';
import '../../styles/home-selector.css';

const CATEGORIES = [
  { key: 'acro', name: 'ACRO', logo: '/acro.png' },
  { key: 'aer', name: 'AER', logo: '/aer.png' },
  { key: 'gaf', name: 'GAF', logo: '/gaf.png' },
  { key: 'gam', name: 'GAM', logo: '/gam.png' },
  { key: 'gpt', name: 'GPT', logo: '/gpt.png' },
  { key: 'gr', name: 'GR', logo: '/gr.png' },
  { key: 'gt', name: 'GT', logo: '/gt.png' },
  { key: 'pk', name: 'PK', logo: '/pk.png' },
];

const CategoryFooter = () => {
  const year = new Date().getFullYear();
  return (
    <div className="category-footer">
      <div className="category-footer-logos">
        {CATEGORIES.map(cat => (
          <img
            key={cat.key}
            src={cat.logo}
            alt={cat.name}
            title={cat.name}
            className="category-footer-logo"
          />
        ))}
      </div>
      <span className="category-footer-copy">© {year} CopaGimnasta. Todos los derechos reservados.</span>
    </div>
  );
};

export default CategoryFooter;
